import React from "react";

// Avvolge una sezione della pagina con il comportamento "a fisarmonica" del
// wizard guidato per chi non può mappare (vedi "wizard"/"statoDiPasso" in
// Home.jsx e OrdiniMapping.jsx) — ma SOLO se "stato" non è null: per chi può
// mappare (stato === null) si comporta esattamente come una sezione normale
// di sempre, stesso identico contenuto, nessun avvolgimento aggiuntivo — il
// wizard è un'esperienza in più solo per chi non può mappare, non un
// cambiamento per tutti. "numero"/"titolo" mancanti (undefined/null) per una
// sezione che in modalità normale non ha mai avuto un header numerato (es.
// la scelta del modello PDF): niente <h2> in quel caso.
export default function SezionePasso({ numero, titolo, stato, children }) {
  if (!stato) {
    return (
      <section className="riquadro">
        {titolo && <h2>{numero}. {titolo}</h2>}
        {children}
      </section>
    );
  }
  const { bloccato, completo, espanso, riepilogo, onToggle } = stato;
  if (bloccato) {
    return (
      <section className="riquadro passo-wizard-bloccato">
        <h2>🔒 {numero}. {titolo}</h2>
        <p className="testo-secondario">Completa prima il passaggio precedente.</p>
      </section>
    );
  }
  return (
    <section className="riquadro">
      {completo ? (
        <button type="button" className="passo-wizard-intestazione" onClick={onToggle}>
          <span>✅ {numero}. {titolo}{riepilogo ? ` — ${riepilogo}` : ""}</span>
          <span className="passo-wizard-toggle">{espanso ? "Comprimi ▾" : "Modifica ▸"}</span>
        </button>
      ) : (
        <h2>{numero}. {titolo}</h2>
      )}
      {espanso && <div className={completo ? "passo-wizard-corpo" : undefined}>{children}</div>}
    </section>
  );
}
